var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 93",
    width: 149,
    height: 93,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vehicle-6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #3f3f3f } \n\t\t.s1 { fill: #f69125 } \n\t\t.s2 { fill: #646464 } \n\t\t.s3 { fill: #4e5260 } \n\t\t.s4 { fill: #5a5a5a } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11714",
    className: "s0",
    d: "m72.5 54.8c-1.9 6.4-0.6 8.3 5.6 8.3q20.3 0.1 40.6 0c4.9 0 6.3-1.4 6.4-6.3q0-25.2 0-50.3c-0.1-5.5-1.8-6.8-8.1-6.1v20.6q0 13.2 0 26.3c0 6.9-0.5 7.5-7.3 7.5-12.4 0-24.9 0-37.2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11715",
    className: "s1",
    d: "m147.4 77.3c-1.4-6.2-5.1-9.1-12-9.1-15.2-0.1-30.4 0-45.6 0-7.7 0-15.4-0.1-23.1 0-6.1 0.1-9.6 3-11.2 9.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11716",
    className: "s0",
    d: "m115.4 0c-10.3 0-20.1-0.1-29.9 0.2-1.5 0-4 1.9-4.3 3.2-3.1 16.4-5.9 32.9-9 50h14c8.3 0 16.6-0.1 24.9 0 2.7 0 4.4-0.5 4.4-3.8-0.2-16.3-0.1-32.6-0.1-49.6zm-3.8 9.3v38.7h-37.3c2.1-12.6 4.2-24.8 6.4-36.9 0.1-0.8 1.7-1.7 2.6-1.8 9.3-0.1 18.7 0 28.3 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11717",
    className: "s1",
    d: "m56.8 83.1c0.6 6 3.8 9.6 9.6 9.6q35 0.2 70.1 0c5.8 0 9-3.5 9.8-9.6-2.4-0.9-3.9-0.8-5.4 2.1-2.3 4.7-7.8 4.6-10.6 0-2.3-3.6-4.1-3.6-6.3-0.1-3 4.8-8.1 4.7-11.1-0.2-1.9-3.1-3.9-3.2-5.8-0.2-3.1 5.2-8.1 5.3-11.1 0.2-2-3.2-3.7-3.2-5.7 0.1-2.9 4.8-8 4.9-11 0.1-2.2-3.5-4-3.5-6.4 0.2-2.9 4.5-8 4.4-10.8-0.1-1.6-2.7-1.6-2.7-5.3-2.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11718",
    className: "s0",
    d: "m70.4 66.2l-26.5-38-7.1 5c7.7 11.2 15.4 22.1 23.1 33q0.2 0.3 0.5 0.5 0.3 0.2 0.6 0.4 0.4 0.1 0.7 0.2 0.4 0 0.8 0c2.4-0.1 4.8-0.6 7.9-1.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11719",
    className: "s0",
    d: "m7.7 39.3l-7.7 1.7c0 7-0.1 14 0.1 21.1q0.1 0.4 0.3 0.7 0.2 0.4 0.5 0.7 0.3 0.3 0.6 0.6 0.3 0.2 0.7 0.4c6.3 2.3 12.7 4.5 20.1 7l-4.7-6.2 0.7-0.4c-1.5-5.5-3-10.8-4.5-16.4-5.4-1.4-6.5-2.9-6.1-9.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11720",
    className: "s0",
    d: "m12.8 47.2q0.6-0.3 1.2-0.6 0.7-0.3 1.3-0.6 0.6-0.3 1.2-0.6 0.6-0.4 1.2-0.7c8.3-5.8 16.6-11.6 25-17.4 2.6-1.8 4.8-3.9 2.6-7.1-2.2-3.3-5-1.9-7.6-0.1-8.7 6.1-17.5 12-26.1 18.3-1.4 1-2.1 3.6-2.1 5.4 0 1.1 2 2.2 3.3 3.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11721",
    className: "s1",
    d: "m149.2 79.4h-95.2v1.8c31.7 0.1 63.4 0.1 95.1 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11722",
    className: "s2",
    d: "m34 34.6c-0.2 3.2 17.4 29.7 23.4 35.6 0.9-2.2-16.1-28.3-23.4-35.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11723",
    className: "s3",
    d: "m76.8 66.2h42.1l0.1-0.8h-42.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11724",
    className: "s4",
    d: "m108.4 38.4v-25.5c-8.3 0-16.4-0.1-24.5 0.1q-0.5 0.1-0.8 0.3-0.4 0.2-0.8 0.6-0.3 0.3-0.5 0.7-0.3 0.3-0.4 0.8c-1.5 7.5-2.7 15-4 23zm-18.7-24.6l2.6 0.5c-1.7 7.7-1.9 15.8-5.7 23.1q0.1-3 0.4-6 0.2-2.9 0.6-5.9 0.4-2.9 0.9-5.9 0.6-2.9 1.2-5.8zm7.9 23.2l-1.3-0.3q1.8-11.2 3.7-22.5l1.5 0.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle6);
export default __webpack_public_path__ + "static/media/vehicle-6.8468ae37bbd9ea98e167240bc1fa5276.svg";
export { ForwardRef as ReactComponent };